module.exports = __webpack_public_path__ + "img/no-image.aa135836.png";